<script>
const ACCESSKEYID = 'LTAIaf73dyK72dHv'
const ACCESSKEYSECRET = 'GRv2JMOvMC02F402r2ZHBElebVUB9v'
const BUCTKE = 'sqpro'
const CoursePath = 'wk/course/'
const DesPath = 'wk/des/'
const CharpterPath = 'wk/charpter/'
const BrandPath = 'wk/brandsdata/'
const Images = 'wk/images/'
const Information = 'wk/information/'
const Teacher = 'wk/teacher/'
const TjType = 'wk/tjtype/'
const Others = 'wk/others/'

export default
{
  ACCESSKEYID,
  ACCESSKEYSECRET,
  BUCTKE,
  CoursePath,
  BrandPath,
  Images,
  Information,
  Teacher,
  TjType,
  DesPath,
  CharpterPath,
  Others
}

</script>



// WEBPACK FOOTER //
// src/store/modules/ossparams.vue